import { UpdateRedeemPageVersionApiModel } from '@cxb/editor-stb-api';
import { RedeemPageVersionUpdateProps } from '../../domain/page-version';

export const mapRedeemPageVersionDomainToApiModel = (
  pageVersion: RedeemPageVersionUpdateProps,
  countryIds: string[],
  userSegmentIds: string[],
  tenantId?: string,
): UpdateRedeemPageVersionApiModel => {
  return {
    nameLocalized: { en: pageVersion.titleEnglish, ar: pageVersion.titleArabic },
    internalName: pageVersion.internalName,
    seoTitle: undefined,
    seoDescription: undefined,
    userSegmentIds,
    countryIds,
    metaTags: pageVersion.metaTags,
    tenantId,
  };
};
